const markTypes = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKE_THROUGH: 'strikeThrough',
  COLOR: 'color',
} as const;

export default markTypes;
